function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 5,
  r: 3,
  stroke: "#FF6D39",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 25,
  r: 5,
  stroke: "#FF6D39",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 25,
  r: 5,
  stroke: "#FF6D39",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9999 27C14.8954 27 13.9999 26.1045 13.9999 25C14.0058 22.0108 12.3405 19.269 9.68528 17.896C9.11273 17.5974 8.71958 17.0407 8.62963 16.4013C8.53968 15.7618 8.764 15.1183 9.23195 14.6733L14.6226 9.55064C15.082 9.11388 15.7213 8.92077 16.3457 9.03014C16.9701 9.1395 17.5057 9.5384 17.7893 10.1053C17.7986 10.1226 19.3159 13 21.9999 13C23.1045 13 23.9999 13.8954 23.9999 15C23.9999 16.1045 23.1045 17 21.9999 17C19.5767 16.9575 17.289 15.8736 15.7213 14.0253L13.7853 15.8666C16.4644 18.1436 18.0058 21.484 17.9999 25C17.9999 26.1045 17.1045 27 15.9999 27Z",
  stroke: "#FF6D39",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgCycling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycling);
export default __webpack_public_path__ + "static/media/cycling.221a2edb055cbf13ca56133728027cc1.svg";
export { ForwardRef as ReactComponent };